import React, { useState } from "react";

function CustomerSubGroup() {
  return (
    <div class="RightSideDiv customer-sub-group">
      <div className="row">
        <div className="col-sm-12">
          <div className="setting-right setting-right-table">
            <div className="table-header">
              <div className="search-card">
                <img
                  src={window.getPublicUrl("/assets/images/search-icon.svg")}
                  alt="Search"
                />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Customer Sub Group..."
                  value=""
                />
              </div>
              <div className="table-actions">
                <button className="btn">
                  <img
                    src={window.getPublicUrl("/assets/images/import.svg")}
                    alt="Import"
                  />
                  Import
                </button>
                <button className="btn">
                  <img
                    src={window.getPublicUrl("/assets/images/export.svg")}
                    alt="Export"
                  />
                  Export
                </button>
                <button className="btn add">+ Add New customer</button>
              </div>
            </div>

            <div className="permission-table-inner">
              <table className="custom-table table-striped">
                <thead>
                  <tr>
                    <th className="checkbox">
                      <label className="checbox-cs">
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                      </label>
                    </th>
                    <th className="code">SNO</th>
                    <th className="customer-enname">Customer Group(EN)</th>
                    <th className="customer-group">Customer Group(TC)</th>
                    <th className="sub-group">Customer Sub Group</th>
                    <th className="label-name">Label Name</th>
                    <th className="action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="checkbox">
                      <label className="checbox-cs">
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td className="code">01</td>
                    <td className="customer-enname">Wellcome</td>
                    <td className="customer-group">惠康</td>
                    <td className="label-name">惠康</td>
                    <td className="status">惠康</td>
                    <td className="action">
                      <div class="dropdown">
                        <button class="dropbtn">
                          {" "}
                          <img
                            src={window.getPublicUrl(
                              "/assets/images/dots-icon.svg"
                            )}
                            alt=""
                          />
                        </button>
                        <div class="dropdown-content">
                          <span href="#">View</span>
                          <span href="#">Edit</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------------------add new customer data----------------------------- */}
      <div className="row">
        <div className="col-sm-12">
          <div className="setting-right position-relative">
            <h3>Add New Customer Group</h3>
            <img
              src={window.getPublicUrl("/assets/images/close.svg")}
              className="close"
              alt="Close"
              onClick=""
            />
            <div className="setting-inner">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Code<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Code"
                      name="code"
                      value=""
                      onChange=""
                      onBlur=""
                    />
                    <div className="invalid-feedback d-block">
                      {/* {errors.email} */}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Customer Group(EN)<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter customer group"
                      name="customerGroupEn"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                    {/* {touched.name && errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )} */}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Customer Group(TC)<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter customer group"
                      name="customerGroup"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Label Name<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Label Name"
                      name="LabelName"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="status">
                    Customer Sub Group<strong>*</strong>
                    </label>
                    <select id="status" class="form-control">
                      <option value="">Please Select </option>
                      <option value="inactive">Customer Sub Group 1</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="button-settings">
              <div className="col-sm-12">
                <div className="d-flex justify-content-end gap-3">
                  <button className="reset" onClick="">
                    Reset
                  </button>
                  <button className="save" onClick="" disabled="">
                    save
                    {/* {isLoading ? 'Saving...' : 'Save'} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        {/* ------------------------------------------------edit new customer data----------------------------- */}
        <div className="row">
        <div className="col-sm-12">
          <div className="setting-right position-relative">
            <h3>Edit Customer Group</h3>
            <img
              src={window.getPublicUrl("/assets/images/close.svg")}
              className="close"
              alt="Close"
              onClick=""
            />
            <div className="setting-inner">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Code<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Code"
                      name="code"
                      value=""
                      onChange=""
                      onBlur=""
                    />
                    <div className="invalid-feedback d-block">
                      {/* {errors.email} */}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Customer Group(EN)<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter customer group"
                      name="customerGroupEn"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                    {/* {touched.name && errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )} */}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Customer Group(TC)<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter customer group"
                      name="customerGroup"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      Label Name<strong>*</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Label Name"
                      name="LabelName"
                      value=""
                      onChange=""
                      onBlur=""
                      maxLength=""
                    />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="status">
                    Customer Sub Group<strong>*</strong>
                    </label>
                    <select id="status" class="form-control">
                      <option value="">Please Select </option>
                      <option value="inactive">Customer Sub Group 1</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="button-settings">
              <div className="col-sm-12">
                <div className="d-flex justify-content-end gap-3">
                  <button className="reset" onClick="">
                    Reset
                  </button>
                  <button className="save" onClick="" disabled="">
                    save
                    {/* {isLoading ? 'Saving...' : 'Save'} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerSubGroup;
